export default class PickerConfigurationModel {
    constructor(data?: any) {
        if (!data) {
            return;
        }
        this.isPickerModeEnabled = data.isPickerModeEnabled === true;
        this.onItemPickedCallback = data.onItemPickedCallback;
        this.pickMultiple = data.pickMultiple;
    }

    pickMultiple = false;
    isPickerModeEnabled = false;    
    onItemPickedCallback: Function | null = null;
}